import {Component, Injector} from '@angular/core';
import { LanguageService } from '@core/services/translate/language.service';
import { TranslateComponent } from '@core/components/translate/translate.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends TranslateComponent {
  title = 'SRIS2';

  constructor(
    private languageService: LanguageService,
    injector: Injector,
  ) {
    super(injector);
    this.languageService.initialize();
  }
}
